import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../store/store.ts';
import { DoraFinding } from '../../models/doraFinding.ts';

interface DoraFindingState {
  doraFindings: DoraFinding[];
  selectedDoraFinding: DoraFinding | null;
}

const initialState: DoraFindingState = {
  doraFindings: [],
  selectedDoraFinding: null,
};

const doraFindingSlice = createSlice({
  name: 'doraFinding',
  initialState,
  reducers: {
    setDoraFindings(state, action: PayloadAction<DoraFinding[]>) {
      state.doraFindings = action.payload;
    },
    addDoraFinding(state, action: PayloadAction<DoraFinding>) {
      state.doraFindings.push(action.payload);
    },
    updateDoraFinding(state, action: PayloadAction<DoraFinding>) {
      const index = state.doraFindings.findIndex(finding => finding.id === action.payload.id);
      if (index !== -1) state.doraFindings[index] = action.payload;
    },
    removeDoraFinding(state, action: PayloadAction<number>) {
      state.doraFindings = state.doraFindings.filter(finding => finding.id !== action.payload);
    },
    setSelectedDoraFinding(state, action: PayloadAction<DoraFinding | null>) {
      state.selectedDoraFinding = action.payload;
    },
  },
});

export const {
  setDoraFindings,
  addDoraFinding,
  updateDoraFinding,
  removeDoraFinding,
  setSelectedDoraFinding,
} = doraFindingSlice.actions;

export const selectDoraFindings = (state: RootState) => state.doraFinding.doraFindings;
export const selectSelectedDoraFinding = (state: RootState) => state.doraFinding.selectedDoraFinding;

export default doraFindingSlice.reducer;
